<nz-select [(ngModel)]="selected" (nzOnSearch)="search($event)" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите продукт" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzValue]="op.id" [nzLabel]="op.title | uiLabel"></nz-option>
</nz-select>
